import { ref, watch } from 'vue'

export const useDebouncedValue = (sourceRef, delayMs = 200) => {
  const debounced = ref(sourceRef?.value)
  let timeoutId = null

  watch(
    sourceRef,
    (nextValue) => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      timeoutId = setTimeout(() => {
        debounced.value = nextValue
      }, Number(delayMs) || 0)
    },
    { immediate: true },
  )

  return debounced
}

